import { Injectable, Input } from "@angular/core";
import { MixinInjectorConstructor } from "./mixin";

export const SizeMixin = <CLAZZ extends MixinInjectorConstructor>(Clazz: CLAZZ) => {
  @Injectable()
  abstract class Size extends Clazz {
    @Input()
    public size: "sm" | "md" | "lg" = "md";

    get sm(): boolean {
      return this.size === "sm";
    }

    get md(): boolean {
      return this.size === "md";
    }

    get lg(): boolean {
      return this.size === "lg";
    }
  }

  return Size;
};

export const SizeMixinInputs = ["size"];
